import { useBreakpointValue } from '@chakra-ui/react';
import {
  DESKTOP_SCROLLABLE_MODAL_CONTENT_PROPS,
  MODAL_FOOTER_PB,
  MOBILE_FULL_SCREEN_MODAL_CONTENT_PROPS,
  SCROLLABLE_MODAL_BODY_PROPS,
} from '@/constants/mobileLayout';

/** Shared layout for form-style modals (create league, confirm, string entry, etc.). */
export function useMobileFormModal() {
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? true;

  return {
    isMobile,
    modalSize: isMobile ? ('full' as const) : undefined,
    isCentered: !isMobile,
    scrollBehavior: 'inside' as const,
    contentProps: isMobile ? MOBILE_FULL_SCREEN_MODAL_CONTENT_PROPS : DESKTOP_SCROLLABLE_MODAL_CONTENT_PROPS,
    bodyProps: SCROLLABLE_MODAL_BODY_PROPS,
    footerPb: MODAL_FOOTER_PB,
    titleFontSize: isMobile ? 'xl' : '2xl',
  };
}
